import {CalculationData, CalculationStrategy} from '../calculation.strategy';
import {Dictionary} from '@softline/core';
import {KzAusgabeAllInputCalculationStrategy} from './input-strategies/input-calculation.strategy';
import {KzAusgabe1InputCalculationStrategy} from './input-strategies/kz-ausgabe-1-input.strategy';
import {KzAusgabe2InputCalculationStrategy} from './input-strategies/kz-ausgabe-2-input.strategy';
import {KzAusgabeNInputCalculationStrategy} from './input-strategies/kz-ausgabe-n-input.strategy';

export class KzAusgabeAllCalculationStrategy implements CalculationStrategy {

  private inputStrategies: Record<'1' | '2' | 'N', KzAusgabeAllInputCalculationStrategy> = {
    '1': new KzAusgabe1InputCalculationStrategy(),
    '2': new KzAusgabe2InputCalculationStrategy(),
    'N': new KzAusgabeNInputCalculationStrategy(),
  }

  calculate(data: CalculationData): Dictionary<number | null> {
    const dict = data.dictionary

    const ausgabeEh1 = data.artehs.find(o => o.kzausgabe === '1')
    const ausgabeEh2 = data.artehs.find(o => o.kzausgabe === '2')

    if (!ausgabeEh1 || ! ausgabeEh2 || !data.inputArteh?.kzausgabe) {
      return dict
    }

    return this.inputStrategies[data.inputArteh.kzausgabe].calculate({
      dict,
      ausgabeEh1,
      ausgabeEh2,
      inputArteh: data.inputArteh,
      inputValue: data.inputValue
    })
  }
}
